import i18next from 'i18next';
import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import {
  fetchOwnPreVisitQuestions,
  fetchWorkspacePreVisitQuestions,
  replaceWorkspacePreVisitQuestions,
} from '@/api/preVisit/preVisitApi';
import type { PreVisitQuestion, PreVisitQuestionDraft } from '@/api/preVisit/preVisitApi.types';
import {
  OWN_PRE_VISIT_QUESTIONS_QUERY_KEY,
  PRE_VISIT_QUESTIONS_QUERY_KEY,
} from '@/constants/queryKeys';

export function useWorkspacePreVisitQuestionsQuery(
  isEnabled = true
): UseQueryResult<PreVisitQuestion[], Error> {
  return useQuery({
    queryKey: [...PRE_VISIT_QUESTIONS_QUERY_KEY, i18next.language],
    queryFn: fetchWorkspacePreVisitQuestions,
    enabled: isEnabled,
  });
}

export function useReplaceWorkspacePreVisitQuestionsMutation(): UseMutationResult<
  PreVisitQuestion[],
  Error,
  PreVisitQuestionDraft[]
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: replaceWorkspacePreVisitQuestions,
    onSuccess: function invalidate() {
      queryClient.invalidateQueries({ queryKey: PRE_VISIT_QUESTIONS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: OWN_PRE_VISIT_QUESTIONS_QUERY_KEY });
    },
  });
}

export function useOwnPreVisitQuestionsQuery(
  isEnabled = true
): UseQueryResult<PreVisitQuestion[], Error> {
  return useQuery({
    queryKey: [...OWN_PRE_VISIT_QUESTIONS_QUERY_KEY, i18next.language],
    queryFn: fetchOwnPreVisitQuestions,
    enabled: isEnabled,
  });
}
